module.exports = __webpack_public_path__ + "static/semantic-image-size-73c7ce5e9e914d1f416d9a9b833086ef.png";